export const MODULE_NAME = 'performance-rules';
export const PERFORMANCE_RULES_ROUTE = `/${MODULE_NAME}`;
